import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import type { InfluencerCampaignFilter } from "@/marketing/models/influencerCampaign";
import { influencerCampaignAPIClient } from "../influencerCampaignAPIClient";
import { INFLUENCER_CAMPAIGN_KEYS } from "./keys";

export const INFLUENCER_CAMPAIGN_QUERIES = {
  list: (filter: InfluencerCampaignFilter = {}) =>
    queryOptions({
      queryKey: INFLUENCER_CAMPAIGN_KEYS.list(filter),
      queryFn: () =>
        influencerCampaignAPIClient.listInfluencerCampaigns(filter),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
    }),
  tracker: () =>
    queryOptions({
      queryKey: INFLUENCER_CAMPAIGN_KEYS.tracker(),
      queryFn: () => influencerCampaignAPIClient.listAllInfluencerCampaigns(),
      staleTime: 30 * 1000,
    }),
  detail: (campaignId: string) =>
    queryOptions({
      queryKey: INFLUENCER_CAMPAIGN_KEYS.detail(campaignId),
      queryFn: () =>
        influencerCampaignAPIClient.getInfluencerCampaign(campaignId),
      staleTime: 60 * 1000,
      enabled: campaignId !== "",
    }),
};
